import React, { createContext, useState, useContext } from 'react';

const SidebarContext = createContext<any>(null);

export const SidebarProvider: React.FC<any> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return <SidebarContext.Provider value={{ isOpen, toggleSidebar }}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => {
    return useContext(SidebarContext);
};
